// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2w6Ub","header":"Messages_header__2mZHj"};